import { render, staticRenderFns } from "./ServiceArticleSection.vue?vue&type=template&id=bfff2908&scoped=true&"
import script from "./ServiceArticleSection.vue?vue&type=script&lang=js&"
export * from "./ServiceArticleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff2908",
  null
  
)

export default component.exports